import React from "react";

const CardTag = (props) => {
    const themeClasses = {
        'primary': 'text-lavender bg-lavender-light',
        'success': 'text-success bg-success-light',
        'danger': 'text-danger bg-danger-light'
    }

    return (
        <div className={`w-max min-h-[23px] px-2 rounded-xl text-xs flex items-center ${themeClasses[props.theme || 'primary']}`}>
            {props.text}
        </div>
    )
}

export default CardTag